import React from 'react'
import { Typography, Input, Row, Col, Card } from 'antd'
import PropTypes from 'prop-types'
import styles from './Flockler.module.css'

const Flockler = ({ flockler, setFlockler }) => {
  const { Title } = Typography
  const { TextArea } = Input

  const handleHeaderChange = ({ target }) => {
    setFlockler({ ...flockler, header: target.value })
  }

  const handleUrlChange = ({ target }) => {
    setFlockler({ ...flockler, embed_url: target.value })
  }

  return (
    <div className={styles['flocker-container']}>
      <Card className={ styles['card-container'] }>
        <Row align={'left'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Section Header*</Title></Col>
        </Row>
        <Row>
          <TextArea
            autoSize={{ minRows: 1 }}
            maxLength={155}
            onChange={handleHeaderChange}
            style={{ width: '100%' }}
            value={flockler?.header}
          />
        </Row>
        {flockler && !flockler.header && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
        <br />
        <br />
        <Row align={'left'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Embed Url*</Title></Col>
        </Row>
        <Row>
          <TextArea
            onChange={handleUrlChange}
            style={{ width: '100%' }}
            value={flockler?.embed_url}
          />
        </Row>
        {flockler && !flockler.embed_url && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
      </Card>
    </div>
  )
}

Flockler.propTypes = {
  flockler: PropTypes.object,
  setFlockler: PropTypes.func
}

export default Flockler
